<div class="actionConfirmation_container">
    <h1 mat-dialog-title>{{title}}</h1>
    <div mat-dialog-content>
      {{message}}
    </div>
    <div class="actionConfirmation_actionsContainer">
      <button mat-raised-button class="actionConfirmation_button" (click)="onCancel()">{{cancelButtonText | translate}}</button>
      <button mat-raised-button class="actionConfirmation_button" color="warn" (click)="onConfirm()">{{confirmButtonText | translate}}</button>
    </div>
</div>
